import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "titlePages text-h5 font-weight-bold text-white mb-0" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "d-flex align-center gap-1 justify-space-between" }
const _hoisted_4 = { class: "clean-th-text" }
const _hoisted_5 = {
  key: 0,
  class: "clean-sort-icon"
}
const _hoisted_6 = ["onClick"]
const _hoisted_7 = {
  key: 1,
  class: "clean-ip-text"
}
const _hoisted_8 = {
  key: 2,
  class: "font-weight-bold text-white"
}
const _hoisted_9 = {
  key: 3,
  class: "d-inline-flex align-center gap-1"
}
const _hoisted_10 = {
  key: 4,
  class: "clean-cell-text"
}

import { ref, Ref, onMounted, onUnmounted, computed } from 'vue';

/********************************
 ********** CONSTANTES **********
 *******************************/
import CONSTAPIS from '@/constants/apis';
import { MONITOREO } from '@/constants/monitoring';

/********************************
 ********** COMPONENTS **********
 *******************************/
import { VueDraggableNext } from 'vue-draggable-next';
import Prog_circular from '@/components/PrincipalComponents/Prog_circular.vue';

/********************************
 ********** INTERFACES **********
 *******************************/
import { ALLHEADERFIX, HEADERFIX } from '@/interfaces/SmartLink/Tables';
import { MONITORING } from '@/interfaces/GestorHCGLINK/Equips';
import { STRINGS } from '@/interfaces/SmartLink/General';

/********************************
 ************ I18N **************
 *******************************/
import { useI18n } from 'vue-i18n';
import { getInfoByIP } from '@/functions/project';


export default /*@__PURE__*/_defineComponent({
  __name: 'MonitoringView',
  setup(__props) {

const { t } = useI18n();

/********************************
 *********** FUNCTION ***********
 *******************************/
const sortKey = ref('');
const sortDesc = ref(false);

function sortBy(key: string) {
  if (sortKey.value === key) {
    sortDesc.value = !sortDesc.value;
  } else {
    sortKey.value = key;
    sortDesc.value = false;
  }
}

// Clase para estilos de los chips de estado
const getStatusChipClass = (status: string) => {
  if (status === 'connected' || status === 'online') {
    return 'status-connected';
  }
  if (status === 'searching' || status === 'connecting') {
    return 'status-searching';
  }
  return 'status-disconnected';
};

// Color dinámico para íconos de señal RSRQ
const getSignalColor = (val: string) => {
  if (!val) return 'grey';
  const num = parseInt(val);
  if (num >= -7) return 'teal-accent-3';
  if (num >= -10) return 'amber-accent-2';
  return 'red-accent-2';
};

// Computada para ordenar items
const sortedItems = computed(() => {
  if (!sortKey.value) return arrayOfObjects.value;

  return [...arrayOfObjects.value].sort((a, b) => {
    const aVal = a[sortKey.value];
    const bVal = b[sortKey.value];

    if (aVal == null) return 1;
    if (bVal == null) return -1;

    if (aVal === bVal) return 0;
    if (sortDesc.value) {
      return aVal < bVal ? 1 : -1;
    } else {
      return aVal > bVal ? 1 : -1;
    }
  });
});

const postURL = (item: any) => {
  window.open(`http://${item.ip}/webfig/#interfaces`, '_blank', 'noopener,noreferrer');
};

const HEADERS: Ref<ALLHEADERFIX> = ref({
  principal: [
    { title: 'status', key: 'status', sortable: true },
    { title: 'name', key: 'name', sortable: true },
    { title: 'ip', key: 'ip', sortable: true },
    { title: 'tipo', key: 'tipo', sortable: true },
    { title: 'imei', key: 'imei', sortable: true },
    { title: 'Primary Band', key: 'primary-band', sortable: true },
    { title: 'DL Modulation', key: 'dl-modulation', sortable: true },
    { title: 'CQI', key: 'cqi', sortable: true },
    { title: 'RI', key: 'ri', sortable: true },
    { title: 'MCS', key: 'mcs', sortable: true },
    { title: 'rssi (dBm)', key: 'rssi', sortable: true },
    { title: 'rsrp (dBm)', key: 'rsrp', sortable: true },
    { title: 'rsrq (dB)', key: 'rsrq', sortable: true },
    { title: 'sinr (dB)', key: 'sinr', sortable: true },
    { title: 'APN', key: 'apn-profiles', sortable: true },
    { title: 'network-mode', key: 'network-mode', sortable: true },
    { title: 'uptime', key: 'session-uptime', sortable: true },
    { title: 'enb-id', key: 'enb-id', sortable: true },
    { title: 'phy-cellid', key: 'phy-cellid', sortable: true },
  ],
  secundary: [{ title: 'phy-cellid', key: 'phy-cellid', sortable: true }],
});

const columnsList: Ref<string[]> = ref([]);
const allColumnsList: Ref<string[]> = ref([]);
const columnSelected = ref('');
const textColumn = ref('');

const ALLHEADER: Ref<HEADERFIX[]> = ref(HEADERS.value.principal);

const changeHeader = (header: Array<HEADERFIX>) => {
  ALLHEADER.value = header;
  getAllColumnsList();
};

const itemsColumns = ref([
  { title: 'Agregar Columnas', value: 1, disabled: computed(() => columnsList.value.length === 0) },
  { title: 'Eliminar Columnas', value: 2, disabled: computed(() => allColumnsList.value.length === 0) },
]);

const agregarColumna = () => {
  ALLHEADER.value.push({
    title: textColumn.value ?? 'Texto Default',
    key: columnSelected.value,
    sortable: true,
  });
  columnsList.value = columnsList.value.filter((item) => item !== columnSelected.value);
  textColumn.value = '';
  columnSelected.value = '';
  dialog.value = false;
  getAllColumnsList();
};

const eliminarColumna = () => {
  ALLHEADER.value = ALLHEADER.value.filter((item: HEADERFIX) => item.key !== columnSelected.value);
  columnsList.value.push(columnSelected.value);
  columnSelected.value = '';
  dialogDelete.value = false;
  getAllColumnsList();
};

const dialog = ref(false);
const dialogDelete = ref(false);
const showDialog = (valor: number) => {
  if (valor === 1) dialog.value = true;
  if (valor === 2) dialogDelete.value = true;
};

const arrayOfObjects = ref<any[]>(MONITOREO);

const getAllColumnsList = () => {
  allColumnsList.value = [];
  ALLHEADER.value.forEach((item: HEADERFIX) => {
    allColumnsList.value.push(item.key);
  });
};

onMounted(async () => {
  getAllColumnsList();
});

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_sheet = _resolveComponent("v-sheet")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_sheet, {
      color: "bgtopology",
      class: "ma-4 defaultCard clean-tech-container"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_row, { class: "mb-1 align-center justify-space-between px-4 pt-2" }, {
          default: _withCtx(() => [
            _createElementVNode("div", null, [
              _createElementVNode("h1", _hoisted_1, _toDisplayString(_unref(t)('title.monitoring')), 1),
              _cache[8] || (_cache[8] = _createElementVNode("p", { class: "text-caption text-grey-lighten-1 mb-0" }, " Visualización de Equipos y Estado de Red ", -1))
            ]),
            _createVNode(_component_v_menu, { location: "bottom end" }, {
              activator: _withCtx(({ props }) => [
                _createVNode(_component_v_btn, _mergeProps(props, {
                  icon: "mdi-menu",
                  variant: "text",
                  color: "grey-lighten-2",
                  density: "comfortable",
                  class: "clean-menu-btn"
                }), null, 16)
              ]),
              default: _withCtx(() => [
                _createVNode(_component_v_list, {
                  nav: "",
                  class: "clean-menu-list"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(itemsColumns.value, (item, i) => {
                      return (_openBlock(), _createBlock(_component_v_list_item, {
                        key: i,
                        value: item.value,
                        title: item.title,
                        class: "nav_item_title",
                        disabled: item.disabled,
                        link: "",
                        onClick: ($event: any) => (showDialog(item.value))
                      }, {
                        prepend: _withCtx(() => [
                          _createVNode(_component_v_icon, {
                            size: "small",
                            color: item.value === 1 ? 'cyan-accent-2' : 'red-lighten-2'
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(item.value === 1 ? 'mdi-table-column-plus-after' : 'mdi-table-column-remove'), 1)
                            ]),
                            _: 2
                          }, 1032, ["color"])
                        ]),
                        _: 2
                      }, 1032, ["value", "title", "disabled", "onClick"]))
                    }), 128))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        (sortedItems.value.length > 0)
          ? (_openBlock(), _createBlock(_component_v_data_table, {
              key: 0,
              headers: ALLHEADER.value,
              items: sortedItems.value,
              "table-class-name": "customize-table clean-table",
              "hide-footer": sortedItems.value.length < 5,
              density: "compact"
            }, {
              headers: _withCtx(() => [
                _createVNode(_unref(VueDraggableNext), {
                  class: "dragArea list-group w-full clean-header-row",
                  list: ALLHEADER.value,
                  tag: "tr",
                  onChange: _cache[0] || (_cache[0] = ($event: any) => (changeHeader(ALLHEADER.value)))
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(ALLHEADER.value, (item, i) => {
                      return (_openBlock(), _createElementBlock("td", {
                        key: item.key ?? i,
                        onClick: ($event: any) => (sortBy(item.key)),
                        class: "clean-th"
                      }, [
                        _createElementVNode("div", _hoisted_3, [
                          _createElementVNode("span", _hoisted_4, _toDisplayString(item.title?.toUpperCase()), 1),
                          (sortKey.value === item.key)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(sortDesc.value ? '▼' : '▲'), 1))
                            : _createCommentVNode("", true)
                        ])
                      ], 8, _hoisted_2))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["list"])
              ]),
              item: _withCtx(({ item }) => [
                _createElementVNode("tr", {
                  class: "monitoreoTR clean-tr",
                  onClick: ($event: any) => (postURL(item))
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(ALLHEADER.value, (header, i) => {
                    return (_openBlock(), _createElementBlock("td", {
                      key: i,
                      class: "clean-td"
                    }, [
                      (header.key === 'status')
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 0,
                            class: _normalizeClass([getStatusChipClass(item.status), "clean-chip"])
                          }, [
                            _cache[9] || (_cache[9] = _createElementVNode("span", { class: "dot" }, null, -1)),
                            _createTextVNode(" " + _toDisplayString(item.status || 'N/A'), 1)
                          ], 2))
                        : (header.key === 'ip')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(item.ip), 1))
                          : (header.key === 'imei')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(item.imei), 1))
                            : (header.key === 'rsrq')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                  _createElementVNode("span", null, _toDisplayString(item[header.key]), 1),
                                  _createVNode(_component_v_icon, {
                                    size: "x-small",
                                    color: getSignalColor(item[header.key]),
                                    class: "ml-1"
                                  }, {
                                    default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                                      _createTextVNode(" mdi-signal-cellular-3 ", -1)
                                    ]))]),
                                    _: 1
                                  }, 8, ["color"])
                                ]))
                              : (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(item[header.key] ?? '-'), 1))
                    ]))
                  }), 128))
                ], 8, _hoisted_6)
              ]),
              _: 1
            }, 8, ["headers", "items", "hide-footer"]))
          : (_openBlock(), _createBlock(_component_v_row, {
              key: 1,
              justify: "center",
              class: "ma-4 pa-8"
            }, {
              default: _withCtx(() => [
                _createVNode(Prog_circular)
              ]),
              _: 1
            })),
        _createVNode(_component_v_divider, {
          thickness: "1",
          color: "white",
          opacity: "0.1",
          class: "mt-4 mb-4"
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_dialog, {
      modelValue: dialog.value,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((dialog).value = $event)),
      width: "450px"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, { class: "clean-dialog pa-4" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, { class: "clean-dialog-title d-flex align-center gap-2 px-0 pt-0" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_icon, { color: "cyan-accent-2" }, {
                  default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                    _createTextVNode("mdi-table-column-plus-after", -1)
                  ]))]),
                  _: 1
                }),
                _cache[12] || (_cache[12] = _createElementVNode("span", null, "Agregar Columna", -1))
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_text, { class: "px-0 py-3" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_row, { density: "compact" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, {
                      cols: "12",
                      class: "mb-2"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_text_field, {
                          "hide-details": "",
                          density: "compact",
                          variant: "outlined",
                          modelValue: textColumn.value,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((textColumn).value = $event)),
                          label: "Nombre Columna",
                          color: "cyan-accent-2",
                          class: "clean-input"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_col, { cols: "12" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_select, {
                          "hide-details": "",
                          density: "compact",
                          variant: "outlined",
                          modelValue: columnSelected.value,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((columnSelected).value = $event)),
                          items: columnsList.value,
                          label: "Valor Columna",
                          color: "cyan-accent-2",
                          class: "clean-input"
                        }, null, 8, ["modelValue", "items"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_actions, { class: "px-0 pb-0" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_btn, {
                  variant: "text",
                  color: "grey-lighten-1",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (dialog.value = false))
                }, {
                  default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                    _createTextVNode("Cancelar", -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_component_v_btn, {
                  color: "cyan-accent-2",
                  variant: "flat",
                  class: "text-black font-weight-bold",
                  onClick: agregarColumna,
                  disabled: textColumn.value === '' || columnSelected.value === ''
                }, {
                  default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                    _createTextVNode(" Agregar ", -1)
                  ]))]),
                  _: 1
                }, 8, ["disabled"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_dialog, {
      modelValue: dialogDelete.value,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((dialogDelete).value = $event)),
      width: "450px"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, { class: "clean-dialog pa-4" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, { class: "clean-dialog-title d-flex align-center gap-2 px-0 pt-0" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_icon, { color: "red-lighten-2" }, {
                  default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                    _createTextVNode("mdi-table-column-remove", -1)
                  ]))]),
                  _: 1
                }),
                _cache[16] || (_cache[16] = _createElementVNode("span", null, "Eliminar Columna", -1))
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_text, { class: "px-0 py-3" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_select, {
                  "hide-details": "",
                  density: "compact",
                  variant: "outlined",
                  modelValue: columnSelected.value,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((columnSelected).value = $event)),
                  items: allColumnsList.value,
                  label: "Seleccionar Columna a Eliminar",
                  color: "cyan-accent-2",
                  class: "clean-input"
                }, null, 8, ["modelValue", "items"])
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_actions, { class: "px-0 pb-0" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_btn, {
                  variant: "text",
                  color: "grey-lighten-1",
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (dialogDelete.value = false))
                }, {
                  default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
                    _createTextVNode("Cancelar", -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_component_v_btn, {
                  color: "red-lighten-1",
                  variant: "flat",
                  class: "text-white font-weight-bold",
                  onClick: eliminarColumna,
                  disabled: columnSelected.value === ''
                }, {
                  default: _withCtx(() => [...(_cache[18] || (_cache[18] = [
                    _createTextVNode(" Eliminar ", -1)
                  ]))]),
                  _: 1
                }, 8, ["disabled"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})